import angular from 'angular';
import snapEngageComponent from './snapEngageComponent';
import './snapEngageStyles.css';

angular
	.module('sh.snapEngage', ['sh.identity'])
	// <sh-snap-engage>
	.directive('shSnapEngage', snapEngageComponent);
